/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { useTranslation } from 'react-i18next';

const PanelDatosContacto = (props) => {
  const { t } = useTranslation('translations');
  const inputClasses = 'shadow appearance-none border rounded w-full py-2 px-3 text-gray-400 text-xs leading-tight focus:outline-none focus:shadow-outline';
  const labelClasses = 'block text-gray-700 text-sm mb-2';
  return (
    <div className='container bg-white my-4 p-6'>
      <div className='panel-body'>
        <div className='text-xl  font-color-mbr-color-primario mb-2'>
          {t('checkout.contactTitle')}
          <i className='fa fa-envelope-o' aria-hidden='true' />
        </div>
        <div className='grid-cols-2 gap-4 text-sm sm:grid grid-cols-1'>
          <div className='col-span-1'>
            <div className='form-group'>
              <label className={labelClasses} htmlFor='mail-contacto'>Email</label>
              <input onChange={props.actualizarDatosContacto} data-name='email' id='mail-contacto' name='mail-contacto' type='email' placeholder={t('checkout.emailTip')} className={inputClasses} required />
            </div>
          </div>
          <div className='col-span-1'>
            <div className='form-group'>
              <label className={labelClasses} htmlFor='telefono-contacto'>{t('checkout.phone')}</label>
              <input onChange={props.actualizarDatosContacto} data-name='telefono' id='telefono-contacto' name='telefono-contacto' type='text' placeholder={t('checkout.phoneTip')} className={inputClasses} required />
            </div>
          </div>
          <div className='col-span-1'>
            <div className='form-group'>
              <label className={labelClasses}>
                <input onClick={props.actualizarCheckbox} data-name='recibir_ofertas_promociones' id='recibir_ofertas' type='checkbox' />
                {' '}
                {t('checkout.acceptNewsletter')}
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PanelDatosContacto;
